import { render } from "./TodoApp.vue?vue&type=template&id=04975b47"
import script from "./TodoApp.vue?vue&type=script&lang=js"
export * from "./TodoApp.vue?vue&type=script&lang=js"

import "./TodoApp.vue?vue&type=style&index=0&id=04975b47&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__